import { useEffect, useState } from "react";
import styles from "./administrationManagment.module.css";
import commonStyles from "components/commonStyle/commonStyle.module.css";
import { FaCheck, FaPlusCircle, FaRegTrashAlt } from "react-icons/fa";
import Popup from "components/Popup/popup";
import SuccessPopup from "components/successPopup/successPopup";
import { getCost } from "services/cost/get-cost";
import { updateCost } from "services/cost/update-cost";
import { setCost } from "services/cost/set-cost";
import { deleteCost } from "services/cost/delete-cost";
import { FaArrowRotateLeft } from "react-icons/fa6";


export default function CostManagment() {
    const [costData, setCostData] = useState<{ id: string; category: string; price: number; }[]>([]);
    const [editedCost, setEditedCost] = useState<{ [key: string]: { category: string; price: number; } }>({});
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [newCost, setNewCost] = useState({ category: "", price: 0.0 });
    const [isSuccessPopupOpen, setIsSuccessPopupOpen] = useState(false);

    const fetchData = async () => {
        try {
            const costs = await getCost();
            setCostData(costs);
        } catch (error) {
            console.error("Fehler beim Abrufen der daten:", error);
        }
    };

    const handleUpdate = async (cost: { id: string; category: string; price: number; }) => {
        try {
            const updatedCost = {
                category: editedCost[cost.id]?.category || cost.category,
                price: editedCost[cost.id]?.price || cost.price,
            };

            await updateCost(cost.id, updatedCost);

            setCostData((prevCostData) =>
                prevCostData.map((item) =>
                    item.id === cost.id ? { ...item, ...updatedCost } : item
                )
            );

            handleEditCanel(cost.id);

            setIsSuccessPopupOpen(true);
        } catch (error) {
            console.error("Fehler beim Aktualisieren der Tarif:", error);
        }
    };


    const handleAdd = async () => {
        try {
            await setCost(newCost);
            fetchData();
            setIsSuccessPopupOpen(true);
        } catch (error) {
            console.error("Fehler beim Hinzufügen einer Tarif:", error);
        }
    };

    const handleEditCanel = (id: string) => {

        const updatedEditedCost = { ...editedCost };
        delete updatedEditedCost[id];
        setEditedCost(updatedEditedCost);
    };

    const handlePopupClose = () => {
        setIsPopupOpen(false);
        setNewCost({ category: "", price: 0.0, })
    };

    const handleDelete = async (id: string) => {
        try {
            await deleteCost(id);
            setIsSuccessPopupOpen(true)
            fetchData();
        } catch (error) {
            console.error("Fehler beim Löschen einer Tarif:", error);
        }

    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <div className={styles.EditForm}>
            {costData.map((cost, index) => (
                <div className={styles.costRow} key={cost.id} >

                    <div className={commonStyles.formGroup}>
                        <label htmlFor="category">Kategorie*</label>
                        <input
                            type="text"
                            id="category"
                            name="category"
                            value={editedCost[cost.id]?.category || cost.category}
                            required
                            onChange={(e) => {
                                setEditedCost({
                                    ...editedCost,
                                    [cost.id]: {
                                        ...editedCost[cost.id],
                                        category: e.target.value,
                                    },
                                });
                            }}
                        />
                    </div>
                    <div className={commonStyles.formGroup}>
                        <label htmlFor="preis">Preis*</label>
                        <input
                            id="preis"
                            name="preis"
                            type="number"
                            value={
                                typeof (editedCost[cost.id]?.price ?? cost.price) === "number"
                                    ? (editedCost[cost.id]?.price ?? cost.price).toFixed(2)
                                    : "0.00"
                            }

                            required
                            onChange={(e) => {
                                const value = parseFloat(e.target.value);
                                setEditedCost((prev) => ({
                                    ...prev,
                                    [cost.id]: {
                                        ...prev[cost.id],
                                        price: isNaN(value) ? 0 : value,
                                    },
                                }));
                            }}
                            onBlur={(e) => {
                                const value = parseFloat(e.target.value);
                                setEditedCost((prev) => ({
                                    ...prev,
                                    [cost.id]: {
                                        ...prev[cost.id],
                                        price: !isNaN(value) ? parseFloat(value.toFixed(2)) : cost.price,
                                    },
                                }));
                            }}
                            style={{ appearance: "textfield" }}
                        />
                    </div>



                    <div className={styles.costActionButtons}>
                        <button
                            type="button"
                            className={styles.removeButton}
                            onClick={() => { handleDelete(cost.id) }}
                        >
                            <FaRegTrashAlt />
                        </button>
                        {editedCost[cost.id] &&
                            (
                                (editedCost[cost.id].price !== undefined && editedCost[cost.id].price !== cost.price) ||
                                (editedCost[cost.id].category !== undefined && editedCost[cost.id].category !== cost.category)
                            ) ? (
                            <><button
                                type="button"
                                className={styles.editButton}
                                onClick={() => handleUpdate(cost)}

                            >
                                <FaCheck />
                            </button>
                                <button
                                    type="button"
                                    className={styles.cancelButton}
                                    onClick={() => { handleEditCanel(cost.id) }}
                                >
                                    <FaArrowRotateLeft />
                                </button></>) : <></>}

                    </div>

                </div>
            ))}
            <section className={styles.section}>
                <div className={styles.addButtonContainer}>
                    <button
                        type="button"
                        className={`${commonStyles.commonButton} ${styles.addfaqButton}`}
                        onClick={() => { setIsPopupOpen(true); }}
                    >
                        <span>Tarif hinzufügen</span>
                        <FaPlusCircle className={`${commonStyles.commonButtonIcon} ${styles.buttonIcon}`} />
                    </button>
                </div>
            </section>

            <Popup
                title={"Tarif hinzufügen"}
                submitLabel={"Hinzufügen"}
                closeLabel={"Abbrechen"}
                isWithButton={true}
                isOpen={isPopupOpen}
                onClose={handlePopupClose}
                onSubmit={handleAdd}
            >

                <div className={commonStyles.formGroup}>
                    <label htmlFor="question">Kategorie*</label>
                    <input
                        type="text"
                        id="question"
                        name="question"
                        value={newCost.category}
                        required
                        onChange={(e) => setNewCost({ ...newCost, category: e.target.value })}
                    />
                </div>
                <div className={commonStyles.formGroup}>
                    <label htmlFor="price">Preis*</label>
                    <input
                        id="price"
                        name="price"
                        type="number"
                        value={newCost.price.toFixed(2)}
                        required
                        onChange={(e) => setNewCost({ ...newCost, price: parseFloat(e.target.value) || 0, })}
                    />
                </div>
            </Popup>


            <SuccessPopup isPopupOpen={isSuccessPopupOpen} onClose={() => {
                handlePopupClose();
                setIsSuccessPopupOpen(false);
            }} />
        </div>
    );
}
